import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <div className="navigation-main">
            <a href="/">
              <div className="navigation-logo-link">
                <span className="navigation-brand section-title">BidWally</span>
              </div>
            </a>
            <div className="navigation-desktop-menu">
              <a href="/map-view">
                <div className="navigation-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"></path>
                  </svg>
                  <span>
                    {' '}
                    Explore Map
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </a>
              <a href="/category-browse">
                <div className="navigation-link">
                  <span>Categories</span>
                </div>
              </a>
              <a href="/trust-safety">
                <div className="navigation-link">
                  <span>Trust &amp; Safety</span>
                </div>
              </a>
            </div>
            <div className="navigation-actions">
              <a href="#" className="link-disabled" aria-disabled="true" tabIndex="-1">
                <div className="navigation-post-btn btn btn-primary btn-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M8 12h8m-4-4v8"></path>
                  </svg>
                  <span>
                    {' '}
                    Post Listing
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
              </a>
              <a href="/seller-profile">
                <div className="navigation-profile-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="10" r="3"></circle>
                    <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path>
                  </svg>
                </div>
              </a>
              <button
                id="navToggle"
                aria-expanded="false"
                aria-label="Toggle navigation"
                className="navigation-toggle"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div id="navOverlay" className="navigation-overlay">
          <div className="navigation-overlay-header">
            <a href="/">
              <div className="navigation-logo-link">
                <span className="navigation-brand section-title">BidWally</span>
              </div>
            </a>
            <button
              id="navClose"
              aria-label="Close navigation"
              className="navigation-close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6L6 18M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <div className="navigation-overlay-content">
            <div className="navigation-mobile-links">
              <a href="/">
                <div className="navigation-mobile-link">
                  <span>Home</span>
                </div>
              </a>
              <a href="/map-view">
                <div className="navigation-mobile-link">
                  <span>Explore Map</span>
                </div>
              </a>
              <a href="/category-browse">
                <div className="navigation-mobile-link">
                  <span>Categories</span>
                </div>
              </a>
              <a href="/trust-safety">
                <div className="navigation-mobile-link">
                  <span>Trust &amp; Safety</span>
                </div>
              </a>
              <a href="/seller-profile">
                <div className="navigation-mobile-link">
                  <span>My Profile</span>
                </div>
              </a>
            </div>
            <div className="navigation-mobile-footer">
              <a href="#" className="link-disabled" aria-disabled="true" tabIndex="-1">
                <div className="btn btn-primary btn-lg">
                  <span>Post a Listing</span>
                </div>
              </a>
              <p className="navigation-trust-note section-content">
                Non-custodial. Peer-to-peer. Secure.
              </p>
            </div>
          </div>
        </div>
      </nav>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById('navToggle');
  const navClose = document.getElementById('navClose');
  const navOverlay = document.getElementById('navOverlay');

  function openNav() {
    navOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    navToggle.setAttribute('aria-expanded', 'true');
  }

  function closeNav() {
    navOverlay.style.display = 'none';
    document.body.style.overflow = '';
    navToggle.setAttribute('aria-expanded', 'false');
  }

  navToggle.addEventListener('click', openNav);
  navClose.addEventListener('click', closeNav);

  navOverlay.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeNav);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 767 && navOverlay.style.display === 'flex') {
      closeNav();
    }
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
